module.exports = __webpack_public_path__ + "static/media/cover.a6a0568e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/bokus/cover.jpg
// module id = 55
// module chunks = 0